import React, { FC, useEffect, useMemo, useRef, useState } from 'react'
import { Link, useNavigate } from 'react-router-dom'
import { fetchData, formatNumber, getTranslatedValue, toasterrormsg, toastsuccessmsg } from '../../../../reusable'
import { PageTitle } from '../../../../_metronic/layout/core'
import { KTIcon } from '../../../../_metronic/helpers'
import { ToastContainer } from 'react-toastify'
import DataTable from 'react-data-table-component'
import Loader from '../../component/Loader'
import clsx from 'clsx'
import moment from 'moment'
import Swal from 'sweetalert2'
import { Tr } from '../../../../_metronic/i18n/Tr'
import { useLang } from '../../../../_metronic/i18n/Metronici18n'

const ViewSpaceRentalBooking: FC = () => {

  const t = Tr()
  const lang = useLang()
  const navigate = useNavigate()
  const categoryId = sessionStorage.getItem('categoryId');
  useEffect(() => {
    if (categoryId != '4') {
      navigate('../dashboard/');
    }
  }, [categoryId])

  var vendorId = "";
  const vendorData = sessionStorage.getItem("vendor");
  if (vendorData) {
    var vendor = JSON.parse(vendorData);
    vendorId = vendor.vendorId;

  } else {
    console.log("No vendor data found");
  }
  const [offset, setoffset] = useState(0)
  const [limit, setlimit] = useState(9)
  const [page, setpage] = useState(1)
  const [totalPage, setTotalPage] = useState(1)
  const [from, setfrom] = useState(1)
  const [to, setTo] = useState(1)
  const [spaceRentalList, setSpaceRentalList] = useState([])
  const [orgSpaceRentalList, setOrgSpaceRentalList] = useState([])
  const [pageNumbersList, setPageNumberList] = useState([1])
  const [statusTab, setStatusTab] = useState("");
  const [searchTerm, setSearchTerm] = useState('')
  const [focus, setFocus] = useState('')
  const [isLoading, setIsLoading] = useState(false)

  // page number generater
  function generatePageNumbers(currentPage: any, totalPages: any, maxPagesToShow: any) {
    const halfMaxPages = Math.floor(maxPagesToShow / 2)
    let startPage = Math.max(1, currentPage - halfMaxPages)
    let endPage = Math.min(totalPages, startPage + maxPagesToShow - 1)

    // Adjust startPage and endPage if the total pages to show is less than maxPagesToShow
    if (endPage - startPage + 1 < maxPagesToShow) {
      startPage = Math.max(1, endPage - maxPagesToShow + 1)
    }

    // Generate the list of page numbers
    const pageNumbers = []
    for (let i = startPage; i <= endPage; i++) {
      pageNumbers.push(i)
    }

    return pageNumbers
  }

  const onpagecahnge = (pageId: any, data: any = [], fromSearch: any = false) => {
    var newdata: any = []
    if (fromSearch == true) {
      newdata = [...data]
    } else {
      newdata = [...orgSpaceRentalList]
    }
    if ((pageId != page && pageId != 0 && pageId <= totalPage) || data.length > 0) {
      var tmp = (pageId - 1) * limit
      setpage(pageId)
      setoffset(tmp)
      setfrom(tmp + 1)
      // setto
      var mod = newdata.length % limit
      var tolimi: any = limit
      if (mod > 0) {
        if (mod <= limit) {
          tolimi = pageId * limit
          if (tolimi > newdata.length) {
            tolimi = newdata.length
          }
        } else {
          tolimi = pageId * limit + limit
          if (tolimi > newdata.length) {
            tolimi = newdata.length
          }
        }
      } else {
        tolimi = pageId * limit
      }
      setTo(tolimi)
      var tmpdata: any = newdata.slice(tmp, tolimi)
      setSpaceRentalList(tmpdata)
    } else if (data.length == 0) {
      setTo(0)
      setfrom(0)
    }
  }
  //   booking list api call
  const bookingListApiCall = async (status: any = '') => {
    setIsLoading(true)
    var param: any = {
      vendorId: String(vendorId),
      categoryId: "4",
      status:status
    }
    var res = await fetchData('public/bookingList', param)

    if (res.status == '200') {
      setIsLoading(false)

      var data = res.data
      setSpaceRentalList(data)
      setOrgSpaceRentalList(data)
    } else {
      toasterrormsg(res.message)
    }
  }

  //   change status for approve api call
  const approveBookingApiCall = (id: any) => {
    Swal.fire({
      title: t('Are you sure?'),
      text: t(`You Want To Approve Booking`),
      icon: 'warning',
      showCancelButton: true,
      confirmButtonText: t('Yes'),
      cancelButtonText: t('No'),
    }).then(async (result) => {
      if (result.isConfirmed) {
        var param = {
          vendorId: vendorId,
          categoryId: categoryId,
          bookingId: id,
          status: 1
        }
        var res = await fetchData('public/bookingStatusChange', param)

        if (res.status == '200') {
          toastsuccessmsg(t("Booking Approved."))
          bookingListApiCall()
        } else {
          toasterrormsg(res.message)
        }
      }
    })
  }
  //   change status for reject api call
  const rejectBookingApiCall = (id: any) => {
    Swal.fire({
      title: t('Are you sure?'),
      text: t(`You Want To Reject Booking`),
      icon: 'warning',
      showCancelButton: true,
      input: 'text',
      inputPlaceholder: t("Enter Reject Reason"),
      inputValidator: (value) => {
        if (!value) {
          return t('You need to enter a reject reason!');
        }
      },
      confirmButtonText: t('Yes'),
      cancelButtonText: t('No'),
    }).then(async (result) => {
      if (result.isConfirmed) {
        var param = {
          vendorId: vendorId,
          categoryId: categoryId,
          bookingId: id,
          status: 2,
          reason: result.value
        }
        var res = await fetchData('public/bookingStatusChange', param)

        if (res.status == '200') {
          toastsuccessmsg(t("Booking Rejected."))
          bookingListApiCall()
        } else {
          toasterrormsg(res.message)
        }
      }
    })
  }

  // search Data
  const searchData = async (text: any, isfoc: any) => {
    setSearchTerm(text)
    setFocus(isfoc)

    if (text == '' || text == null || text == undefined) {
      var tmp: any = orgSpaceRentalList.slice(offset, offset + limit)

      setSpaceRentalList(tmp)
      var totpag = Math.ceil(orgSpaceRentalList.length / limit)
      setTotalPage(totpag)
      setSpaceRentalList(orgSpaceRentalList)
      onpagecahnge(1, orgSpaceRentalList, true)
      setpage(1)
      var genpag = generatePageNumbers(1, totpag, 6)
      setPageNumberList(genpag)
    } else {
      var tmp: any = orgSpaceRentalList.filter((item: any) => {

        return (
          (item.enName != null &&
            item.enName != '' &&
            item.enName.toLowerCase().includes(text.toLowerCase())) ||
          (item.ruName != null &&
            item.ruName != '' &&
            item.ruName.toLowerCase().includes(text.toLowerCase())) ||
          (item.uzName != null &&
            item.uzName != '' &&
            item.uzName.toLowerCase().includes(text.toLowerCase()))
        )
      })
      var totpag = Math.ceil(tmp.length / limit)
      setTotalPage(totpag)
      setSpaceRentalList(tmp)
      onpagecahnge(1, tmp, true)
      setpage(1)
      var genpag = generatePageNumbers(1, totpag, 6)
      setPageNumberList(genpag)
    }
  }

  const CustomHeader = (props: any) => {
    const inputRef: any = useRef(null)

    // Define the onchange event handler
    const handleChange = async (e: any) => {

      // Focus on the input element when the onchange event is triggered
      await props.fnserch(e, 1)
      // inputRef.current.focus();
    }
    useEffect(() => {
      // Check if the ref exists and if the component should be focused
      if (inputRef.current && props.isfoc === 1) {
        inputRef.current.focus()
      }
    }, [props.isfoc])
    return (
      <div className='d-flex justify-content-between flex-wrap w-100 my-5'>
        <div className='d-flex align-items-center position-relative my-1 '>
          <KTIcon iconName='magnifier' className='fs-1 position-absolute ms-6' />
          <input
            type='text'
            data-kt-user-table-filter='search'
            className='form-control form-control-solid w-250px ps-14'
            placeholder={t('Search Name')}
            value={props.search}
            onChange={(e: any) => handleChange(e.target.value)}
            ref={inputRef}
          />
        </div>
      </div>
    )
  }
  // Define your DataTable columns
  const column = useMemo(
    () => [
      {
        name: (<label className='fw-bold fs-6 text-muted'>{t('#')}</label>),
        selector: (row: any, index: any) => index + 1, // Add 1 to start from 1 instead of 0
        width: '50px',
      },
      {
        name: (<label className='fw-bold fs-6 text-muted'>{t('Action')}</label>),
        cell: (row: any) => (
          <>
            {row.status == 0 && (
              <button
                onClick={() => { approveBookingApiCall(row.bookingId) }}
                className='btn btn-sm btn-icon btn-color-primary btn-active-light-primary'
                data-kt-menu-trigger='click'
                data-kt-menu-placement='bottom-end'
                data-kt-menu-flip='top-end'
                data-toggle="tooltip"
                title="Approve"
              >
                <KTIcon iconName='check-square' className='fs-2x text-primary' />
              </button>
            )
            }
            {row.status == 0 && (
              <button
                onClick={() => { rejectBookingApiCall(row.bookingId) }}
                className='btn btn-sm btn-icon btn-color-danger btn-active-light-danger'
                data-kt-menu-trigger='click'
                data-kt-menu-placement='bottom-end'
                data-kt-menu-flip='top-end'
                data-toggle="tooltip"
                title="Reject"
              >
                <KTIcon iconName='cross-square' className='fs-2x text-danger' />
              </button>
            )}
          </>
        ),
      },
      {
        name: (<label className='fw-bold fs-6 text-muted'>{t('Booking Status')}</label>),
        cell: (row: any) => (
          <div className='my-3'>
            {row.status == 0 ? (
              <span className='btn btn-warning mx-2 p-1 btn-sm fw-bold w-100px pointer-events-none'>{t('Pending')}</span>
            ) : row.status == 1 ? (
              <span className='btn btn-success mx-2 p-1 btn-sm fw-bold w-100px pointer-events-none'>{t('Approved')}</span>
            ) : row.status == 2 ? (
              <span className='btn btn-light-danger mx-2 p-1 btn-sm fw-bold w-100px pointer-events-none'>{t('Rejected')}</span>
            ) : row.status == 3 ? (
              <>
                <span className='btn btn-danger mx-2 p-1 btn-sm fw-bold w-100px pointer-events-none'>{t('Cancelled')}</span> <br />
                <div className='text-center mt-2'>
                  {' '}
                  <span className='fw-bold fs-6'>
                    ({row.cancellationCharge ? row.cancellationCharge + `% ${t('Charges')}` : `0% ${t('Charges')}`})
                  </span>
                </div>
              </>
            ) : (
              <span className='btn btn-success mx-2 p-1 btn-sm fw-bold w-100px pointer-events-none'>{t('Completed')}</span>
            )}
          </div>
        ),
        sortable: false,
        filter: true,
        width: '200px',
      },
      {
        name: (<label className='fw-bold fs-6 text-muted'>{t('Booking ID')}</label>),
        cell: (row: any) => (
          <div className='my-3'>
            <div className='d-flex align-items-center justify-content-center'>
              <label className='fs-6 fw-bold cursor-pointer'>
                <Link
                  to='../viewspacebookingdetails/'
                  state={{ bookingId: row.bookingId }}
                  className='text-primary text-decoration-underline fw-bold text-hover-primary mx-2'
                >
                  {row.bookingCode ? '#' + row.bookingCode : ''}
                </Link>
              </label>
            </div>
          </div>
        ),
        sortable: false,
        filter: true,
        width: '250px',
      },
      {
        name: (<label className='fw-bold fs-6 text-muted'>{t('Guest Name')}</label>),
        cell: (row: any) => (
          <div className='my-3'>
            <div className='d-flex align-items-center justify-content-center'>
              <label className='fs-6 fw-bold'>{row.guestName ? row.guestName : '---'}</label>
            </div>
          </div>
        ),
        sortable: true,
        filter: true,
        width: '250px',
        selector: (row: any) =>
          row.enName ? row.enName : '',
      },
      {
        name: (<label className='fw-bold fs-6 text-muted'>{t('Renting Date')}</label>),
        cell: (row: any) => (
          <div className='my-3'>
            <div className='fw-bold fs-5'>{row.rentingDate ? moment(row.rentingDate).format('DD.MM.YYYY') : '---'}</div>
          </div>
        ),
        sortable: false,
        filter: true,
        width: '200px',
      },
      {
        name: (<label className='fw-bold fs-6 text-muted'>{t('Hours')}</label>),
        cell: (row: any) => (
          <div className='my-3'>
            <div className='fw-bold fs-5'>{row.hours ? row.hours : '---'}</div>
          </div>
        ),
        sortable: false,
        filter: true,
        width: '200px',
      },
      {
        name: (<label className='fw-bold fs-6 text-muted'>{t('Rental Hours')}</label>),
        cell: (row: any) => (
          <div className='my-3'>
            <div className='fw-bold fs-5'>{row.rentingHours ? row.rentingHours : '---'}</div>
          </div>
        ),
        sortable: false,
        filter: true,
        width: '200px',
      },
      {
        name: (<label className='fw-bold fs-6 text-muted'>{t('Space Name')}</label>),
        cell: (row: any) => (
          <div className='my-3'>
            <div className='fw-bold fs-5'>{getTranslatedValue(lang, row, '_actionName') || '-'}</div>{' '}
          </div>
        ),
        sortable: true,
        selector: (row: any) => getTranslatedValue(lang, row, '_actionName'),
        filter: true,
        width: '222px',
      },
      {
        name: (<label className='fw-bold fs-6 text-muted'>{t('Rental Space Name')}</label>),
        cell: (row: any) => (
          <div className='my-3'>
            <div className='d-flex align-items-center justify-content-center'>
              <label className='fs-6 fw-bold cursor-pointer'>{getTranslatedValue(lang, row, '_name')}</label>
            </div>
          </div>
        ),
        sortable: true,
        filter: true,
        width: '250px',
        selector: (row: any) =>
          getTranslatedValue(lang, row, '_name'),
      },
      {
        name: (<label className='fw-bold fs-6 text-muted'>{t('Booked On')}</label>),
        cell: (row: any) => (
          <div className='my-3'>
            <div className='fw-bold fs-5'>{row.created ? moment(row.created).format('DD.MM.YYYY') : '---'}</div>
          </div>
        ),
        sortable: false,
        filter: true,
        width: '200px',
      },
      {
        name: (<label className='fw-bold fs-6 text-muted'>{t('Original Amount')}</label>),
        cell: (row: any) => (
          <div className='my-3'>
            <div className='d-flex align-items-center justify-content-center'>
              <label className='fs-6 fw-bold'>{row.originalAmount >= 0 ? formatNumber(row.originalAmount) + ' UZS' : '---'}</label>
            </div>
          </div>
        ),
        sortable: false,
        filter: true,
        width: '200px',
      },
      {
        name: (<label className='fw-bold fs-6 text-muted'>{t('Final Amount')}</label>),
        cell: (row: any) => (
          <div className='my-3'>
            <div className='d-flex align-items-center justify-content-center'>
              <label className='fs-6 fw-bold'>{row.totalAmount >= 0 ? formatNumber(row.totalAmount) + ' UZS' : ''}</label>
            </div>
          </div>
        ),
        sortable: false,
        filter: true,
        width: '200px',
      },
      {
        name: (<label className='fw-bold fs-6 text-muted'>{t('Insayr Service Fee')}</label>),
        cell: (row: any) => (
          <div className='my-3'>
            <div className='d-flex align-items-center justify-content-center'>
              <label className='fs-6 fw-bold'>{row.InsayrServiceFee >= 0 ? formatNumber(row.InsayrServiceFee) + ' UZS' : '---'}</label>
            </div>
          </div>
        ),
        sortable: false,
        filter: true,
        width: '200px',
      },
    ],
    [t]
  )
  useEffect(() => {
    bookingListApiCall()
  }, [])

  return (
    <>
      {isLoading && <Loader />}
      <ToastContainer />
      <PageTitle breadcrumbs={[]}>{t('View Booking List')}</PageTitle>
      {
        <div className="card card-flush py-4">
          <div className="card-body pt-0">
            <div className='card card-custom'>
              <div className='card-header card-header-stretch overflow-auto'>
                <ul
                  className='nav nav-stretch nav-line-tabs fw-semibold border-transparent flex-nowrap'
                  role='tablist'
                >
                  <li className='nav-item'>
                    <a
                      className={clsx(`nav-link cursor-pointer`, { active: statusTab === '' })}
                      onClick={() => { bookingListApiCall(); setStatusTab(''); }}
                      role='tab'
                    >
                      {t('All')}
                    </a>
                  </li>
                  <li className='nav-item'>
                    <a
                      className={clsx(`nav-link cursor-pointer`, { active: statusTab === '0' })}
                      onClick={() => { bookingListApiCall('0'); setStatusTab('0'); }}
                      role='tab'
                    >
                      {t('Pending')}
                    </a>
                  </li>
                  <li className='nav-item'>
                    <a
                      className={clsx(`nav-link cursor-pointer`, { active: statusTab === '1' })}
                      onClick={() => { bookingListApiCall('1'); setStatusTab('1'); }}
                      role='tab'
                    >
                      {t('Approved')}
                    </a>
                  </li>
                  <li className='nav-item'>
                    <a
                      className={clsx(`nav-link cursor-pointer`, { active: statusTab === '2' })}
                      onClick={() => { bookingListApiCall('2'); setStatusTab('2'); }}
                      role='tab'
                    >
                      {t('Rejected')}
                    </a>
                  </li>
                  <li className='nav-item'>
                    <a
                      className={clsx(`nav-link cursor-pointer`, { active: statusTab === '3' })}
                      onClick={() => { bookingListApiCall('3'); setStatusTab('3'); }}
                      role='tab'
                    >
                      {t('Cancelled')}
                    </a>
                  </li>
                  <li className='nav-item'>
                    <a
                      className={clsx(`nav-link cursor-pointer`, { active: statusTab === '4' })}
                      onClick={() => { bookingListApiCall('4'); setStatusTab('4'); }}
                      role='tab'
                    >
                      {t('Completed')}
                    </a>
                  </li>
                </ul>
              </div>
            </div>
            <DataTable
              columns={column}
              data={spaceRentalList}
              pagination
              paginationServer={false}
              subHeader={true}
              subHeaderComponent={
                <CustomHeader search={searchTerm} isfoc={focus} fnserch={searchData} />
              }
              responsive={true}
            />
          </div>
        </div>
      }
    </>
  )
}

export { ViewSpaceRentalBooking }
